export const SETTINGS_TABS = [
  { id: "company", label: "Company Info" },
  { id: "locations", label: "Office Locations" },
  { id: "reminders", label: "Reminders" },
  // { id: "notifications", label: "Notifications" },
  // { id: "workflow", label: "Workflow" },
  { id: "billing", label: "Billing" },
  { id: "license", label: "License Info", roles: ["owner"] },
  // { id: "rooms", label: "Room Requirement" },
  { id: "termsInfo", label: "Terms & conditions" },
];

export const DEFAULT_COMPANY_INFO = {
  name: "Verve Kitchens",
  email: "info@pinkmoontech.com",
  phone: "+91 9800000000",
  address: "vijayawada, Andhra Pradesh,",
  gst: "36ABCDE1234F1Z5",
  website: "www.pinkmoontech.com",
};
